import { FormControl, FormLabel, Stack } from '@chakra-ui/react';
import { Field } from 'formik';
import { useState } from 'react';

import FieldToolTip from 'components/forms/new/FieldToolTip';
import NameField from 'components/forms/new/formikFormFields/NameField';
import {
    formInputStyles,
    formLabelStyling,
    stackSpacing,
    stackStyling,
} from 'components/forms/new/formStyles';

const ExtensionField = ({
    errors,
    touched,
    darkMode,
    isDisabled = false,
    validationError = { extension: '' },
    mode = 'Add',
}) => {
    const [isHovered, setIsHovered] = useState(false);
    const isEditMode = mode === 'Edit';

    return (
        <FormControl
            isRequired={!isEditMode}
            isInvalid={
                Boolean(errors.extension || validationError.extension) &&
                touched.extension
            }
            sx={{ margin: '0 !important' }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack
                direction="row"
                spacing={stackSpacing}
                sx={{ ...stackStyling(), ...formInputStyles }}>
                <FormLabel sx={formLabelStyling(darkMode)}>
                    Extension{' '}
                    {isEditMode && (
                        <span className="font-medium text-gray-400">
                            (read-only)
                        </span>
                    )}
                </FormLabel>
                <Field name="extension">
                    {({ field }) => (
                        <NameField
                            {...field}
                            pl={2}
                            placeholder="Enter extension number"
                            label="Extension *"
                            darkMode={darkMode}
                            isDisabled={isDisabled}
                            error={
                                errors?.extension || validationError?.extension
                            }
                        />
                    )}
                </Field>
                {isHovered && (
                    <FieldToolTip
                        label={`${isEditMode ? 'Unique extension number for this AOR. This field cannot be edited.' : 'Enter a unique extension number for this AOR. The extension must be unique within the selected registrar.'}`}
                        ariaLabel="extension-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default ExtensionField;
